/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import get from 'lodash/get';

import CommunicatorAnalytics from '../analytics/communicator-analytics';
import CommunicatorOrientation from '../orientation/communicator-orientation';
import CommunicatorStretch from '../stretch/communicator-stretch';
import CommunicatorUtility from '../utility/communicator-utility';
import CommunicatorNumber from '../number/communicator-number';

/**
 * Komunikátor sezení s nastavením zařízení pro Ki-Wi Server.
 */
class CommunicatorSession {
  /**
   * Vytvoří instanci.
   * @param {AutorebootCommunicator} communicatorAutoreboot
   * @param {CommunicatorControl} communicatorControl
   * @param {Session} session Sezení s nastavením zařízení.
   * @returns {CommunicatorSession} Nová instance.
   */
  constructor(communicatorAutoreboot, communicatorControl, session) {
    this.communicatorAutoreboot = communicatorAutoreboot;
    this.communicatorControl = communicatorControl;
    this.session = session;
  }

  /**
   * Zpracuje nastavení zařízení.
   * @param {CommunicatorSettings} communicatorSettings
   * @param {Object} [json] Odpověď na obsah zařízení.
   * @param {Store} store Datový sklad ke vložení nastavení zařízení.
   * @returns {Session} Informace o novém obsahu zařízení.
   */
  parse(communicatorSettings, json, store) {
    const mainJson = get(json, 'main');
    const deviceJson = get(mainJson, 'module.media[0]');
    const visualJson = get(mainJson, 'visualController');
    const { communicatorAutoreboot, communicatorControl } = this;
    // TODO Store update undefined bug
    // - Nesmí zde dojít ke vložení položky s undefined, jinak se bug projeví.

    return store.inject('session', {
      analyticsPeriod: CommunicatorAnalytics.parse(get(deviceJson, 'log')),
      autorebootDisabled:
        communicatorAutoreboot.isDisabled(communicatorSettings),
      autorebootInterval:
        communicatorAutoreboot.getTnterval(communicatorSettings),
      contentTimestamp: CommunicatorUtility.parseDate(
        get(mainJson, 'info.updateTimestamp')
      ),
      genericViewerVideoPreloadBlackeningFix: CommunicatorUtility.parseBoolean(
        communicatorSettings.get('generic.viewer.video.preloadBlackeningFix')
      ),
      genericViewerVideoPreloadBlackeningFixDelay:
        CommunicatorNumber.fromString(
          communicatorSettings.get(
            'generic.viewer.video.preloadBlackeningFixDelay'
          )
        ) || null,
      genericViewerVideoSeekDisable: CommunicatorUtility.parseBoolean(
        communicatorSettings.get('generic.viewer.video.seekDisable')
      ),
      id: this.session.id,
      localControlLock:
        communicatorControl.parseLocalLock(communicatorSettings),
      orientationEnum: CommunicatorOrientation.parse(
        get(visualJson, 'screen[0].orientation')
      ),
      remoteControlLock:
        communicatorControl.parseRemoteLock(communicatorSettings),
      storage: communicatorSettings.get('storage.types'),
      stretchEnum: CommunicatorStretch.parse(get(deviceJson, 'stretching')),
      volume: CommunicatorUtility.parseVolume(get(visualJson, 'volume'))
    });
  }
}

export default CommunicatorSession;
